import './OKLayout.scss'
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
const classnames = require('classnames');
// @components
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import TabbedBox from 'components/commons/tabbedBox/tabbedBox';
// @constant
import {
    NEGATIVE,
    POSITIVE,
} from 'constants/layout';

class LayoutView extends PureComponent {
    render() {
        const {
            activeTab,
            breadcrumb,
            buttons,
            children,
            className,
            contentPosition,
            coverCustomClass,
            onTabSelection,
            overlap,
            loading,
            section,
            size,
            subtitleLeft,
            subtitleRight,
            tabbedBoxIsResponsive,
            tabId,
            tabLeft,
            tabMinWidth,
            tabWidth,
            tabWithBorder,
            tabs,
            tabsAnimated,
            tabsCustomClassName,
            title,
            tutorial,
        } = this.props;
        if (loading) {
            return <LoadingSection />;
        }
        const coverClassnames = classnames('col-xs-12', coverCustomClass);

        return (
            <div className={className}>
                <div className="ok-layout">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size={size} section={section} customClass={coverClassnames}>
                                <OKHeaderSubPage
                                    breadcrumbConfig={breadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    overlap={overlap}
                                    tutorial={tutorial}
                                    finalTitle={title}
                                >
                                    {buttons}
                                </OKHeaderSubPage>
                                {
                                    tabs && tabs.length &&
                                        <TabbedBox
                                            animated={tabsAnimated}
                                            onTabSelection={onTabSelection}
                                            activeTab={activeTab}
                                            id={tabId}
                                            left={tabLeft}
                                            tabs={tabs}
                                            width={tabWidth}
                                            minWidth={tabMinWidth}
                                            customClassName={tabsCustomClassName}
                                            withBorder={tabWithBorder}
                                            isResponsive={tabbedBoxIsResponsive}
                                        />
                                }
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className={classnames(`grid-view--content-position-${contentPosition}`)}>
                                { children }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LayoutView.propTypes = {
    breadcrumb: PropTypes.array,
    buttons: PropTypes.any,
    contentPosition: PropTypes.oneOf([NEGATIVE, POSITIVE]),
    checkAccess: PropTypes.func,
    children: PropTypes.any,
    className: PropTypes.string,
    coverCustomClass: PropTypes.string,
    loading: PropTypes.bool,
    overlap: PropTypes.bool,
    size: PropTypes.string,
    section: PropTypes.string,
    subtitleLeft: PropTypes.string,
    subtitleRight: PropTypes.any,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    tutorial: PropTypes.element,
    // TabbedBox props
    activeTab: PropTypes.number,
    onTabSelection: PropTypes.func,
    tabId: PropTypes.string,
    tabLeft: PropTypes.bool,
    tabMinWidth: PropTypes.number,
    tabWidth: PropTypes.number,
    tabWithBorder: PropTypes.bool,
    tabs: PropTypes.array,
    tabsAnimated: PropTypes.bool,
    tabsCustomClassName: PropTypes.string,
    tabbedBoxIsResponsive: PropTypes.bool,
};

LayoutView.defaultProps = {
    contentPosition: POSITIVE,
    breadcrumb: [],
    checkAccess: () => {},
    loading: false,
    overlap: true,
    size: 'medium',
    subtitleLeft: '',
    subtitleRight: '',
    // TabbedBox props
    tabLeft: true,
    tabWithBorder: false,
    tabsAnimated: true,
    tabbedBoxIsResponsive: false,
}

export default LayoutView;